import trackerService from 'api/tracker';

function ConfirmationModalCtrl($scope, $uibModalInstance, deferred, affiliateId) {
  $scope.createTrackerForm = {
    name: ''
  };

  $scope.createTracker = function(form, $event) {
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return;

    $scope.isSubmittingCreateTracker = true;

    trackerService.create({
        affiliateId: affiliateId,
        name: $scope.createTrackerForm.name
      })
      .then(response => {
        $scope.submitted = false;

        deferred.resolve(response);
      })
      .catch(() => {
        $scope.isSubmittingCreateTracker = false;
        $scope.createTrackerResult = 'error';
      });
  };

  $scope.close = function() {
    deferred.resolve(false);
  };
}

ConfirmationModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'deferred',
  'affiliateId'
];

export default ConfirmationModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/addTracker/controller.js